export default __webpack_public_path__ + "static/pattern-078609888d4d003e746ac80d4ca367c2.png";